import React from "react";
import { Routes, Route } from "react-router-dom";
import DocumentosPage from "../pages/DocumentosPage";
import CarpetaDetallePage from "../pages/CarpetaDetallePage";

const DocumentosRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<DocumentosPage />} />
      <Route path=":id" element={<CarpetaDetallePage />} />
    </Routes>
  );
};

export default DocumentosRoutes;
